__turbopack_context__.v({
  "border": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__border",
  "caption": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__caption",
  "captionItem": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__captionItem",
  "fade-in": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__fade-in",
  "image": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__image",
  "inner": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__inner",
  "isActive": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__isActive",
  "isHovering": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__isHovering",
  "isInteractive": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__isInteractive",
  "isLoading": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__isLoading",
  "media": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__media",
  "mediaItem": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__mediaItem",
  "move-rotate-active": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__move-rotate-active",
  "move-rotate-active-from-hover": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__move-rotate-active-from-hover",
  "move-rotate-inactive": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__move-rotate-inactive",
  "move-rotate-inactive-from-hover": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__move-rotate-inactive-from-hover",
  "root": "TalesBlockTwoImageCycle-module-scss-module___lNcHa__root",
});
